import { app } from "@/main";

class ColumbiaDocumentsService {
  private getApiDataAsync = async (docid: string, selectedSite?: string) => {
    try {
      const data = {
        docid: docid,
        selectedSite: selectedSite
      };

      const apiResponse = await app.$axios.post(
        "/columbia-documents/pdf-location",
        data
      );
      return apiResponse?.data?.Body?.data ?? "";
    } catch (error) {
      return "";
    }
  };

  public loadDataAsync = async (docid: string, selectedSite?: string) => {
    const results: any = await this.getApiDataAsync(docid, selectedSite);
    return results;
  };
}

export const columbiaDocumentsService = new ColumbiaDocumentsService();
